export default __webpack_public_path__ + "static/media/437.38aca2bc.gif";